import { useEffect, useState } from 'react';
import { SALES_HUB_PROFESSIONAL_ONBOARDING } from 'self-service-api/constants/ProductNames';
import { BUY_TOUCHLESS } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import { HC0124_GROUP_PARAMETER_KEY, HC0124_GROUP_PARAMETER_OPTIONS, HC0124_TREATMENT_KEY, PARAMETERS } from '../constants/experimentKeys';
import { laboratoryClient } from '../utils/laboratoryClient';
export const logHC0124Exposure = () => {
  laboratoryClient.logExposure(HC0124_TREATMENT_KEY);
};
const skuApiNames = [SALES_HUB_PROFESSIONAL_ONBOARDING];
export const useIsHC0124Eligible = (isHC0124Fetched, apiName, merchCardPurchaseMotions, purchaseMotions, ownsProductViaBundle) => {
  const [isEligibleForHC0124, setIsEligibleForHC0124] = useState(false);
  const firstMerchCardPurchaseMotion = merchCardPurchaseMotions && merchCardPurchaseMotions[0];
  const firstUpgradeModalPurchaseMotion = purchaseMotions && purchaseMotions[0];
  useEffect(() => {
    if (!ownsProductViaBundle && apiName && isHC0124Fetched && (firstMerchCardPurchaseMotion || firstUpgradeModalPurchaseMotion)) {
      if (skuApiNames.includes(apiName) && BUY_TOUCHLESS === firstMerchCardPurchaseMotion) {
        setIsEligibleForHC0124(true);
      } else {
        setIsEligibleForHC0124(false);
      }
    }
  }, [ownsProductViaBundle, apiName, isHC0124Fetched, firstMerchCardPurchaseMotion, firstUpgradeModalPurchaseMotion]);
  return {
    isEligibleForHC0124
  };
};
export const useIsHC0124Variant = () => {
  const [isHC0124Variant, setIsHC0124Variant] = useState(false);
  const [isHC0124Fetched, setIsHC0124Fetched] = useState(false);
  if (!isHC0124Fetched) {
    laboratoryClient.resolve(treatments => {
      setIsHC0124Fetched(true);
      if (Object.keys(treatments).length) {
        const treatment = treatments[HC0124_TREATMENT_KEY];
        const cohort = treatment[PARAMETERS][HC0124_GROUP_PARAMETER_KEY];
        const isVariant = cohort === HC0124_GROUP_PARAMETER_OPTIONS.variant;
        setIsHC0124Variant(isVariant);
      }
    });
  }
  return {
    isHC0124Variant,
    isHC0124Fetched
  };
};